import { render, staticRenderFns } from "./BuyFromCustomerSlips.vue?vue&type=template&id=f9688882&"
import script from "./BuyFromCustomerSlips.vue?vue&type=script&lang=js&"
export * from "./BuyFromCustomerSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports